import React from 'react';
import HusqvarnaPortalLogo from './HusqvarnaPortalLogo';
import { Button, IconChats, IconUser, MenuIcon } from '../../../components';
import { FormattedMessage, useIntl } from 'react-intl';
import IconSearchDesktop from '../../../components/Topbar/TopbarSearchForm/IconSearchDesktop';
import IconExternalLink from '../../../components/IconExternalLink/IconExternalLink';
import { Form as FinalForm, Field } from 'react-final-form';

import css from './KioskTopbar.module.css';

const KioskTopbar = ({ onSearchSubmit }) => {
  const intl = useIntl();
  return (
    <header className={css.header}>
      <div className={css.leftSection}>
        <a href="/" className={css.logoWrapper}>
          <HusqvarnaPortalLogo />
        </a>

        <div className={css.navigation}>
          <Button
            title={intl.formatMessage({ id: 'Topbar.menuIcon' })}
            rootClassName={css.menuButton}
          >
            <MenuIcon />
          </Button>

          <Button rootClassName={css.navItem}>
            <FormattedMessage id="KioskTopbar.navItem.products" />
          </Button>
          <Button rootClassName={css.navItem}>
            <FormattedMessage id="KioskTopbar.navItem.equipment" />
          </Button>
        </div>
      </div>

      <div className={css.rightSection}>
        <div className={css.buttons}>
          <a
            href="https://hsq-prod.husqvarnagroup.com/B2BFeedbackInputForm/B2B_Feedback_Input?locale=en-001"
            target="_blank"
            rel="noopener noreferrer"
            className={css.iconLink}
          >
            <span className={css.icon}>
              <IconChats />
            </span>
            <span className={css.feedback}>
              <FormattedMessage id="KioskTopbar.feedback" />
              <IconExternalLink />
            </span>
          </a>

          <a
            href="https://portal.husqvarnagroup.com/sso/login"
            target="_blank"
            rel="noopener noreferrer"
            className={css.iconLink}
          >
            <span className={css.icon}>
              <IconUser />
            </span>
            <FormattedMessage id="KioskTopbar.signIn" />
          </a>
        </div>

        <FinalForm
          onSubmit={onSearchSubmit}
          initialValues={{ keywords: '' }}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit} className={css.searchWrapper}>
              <Button type="submit" rootClassName={css.searchIcon}>
                <IconSearchDesktop />
              </Button>

              <Field
                name="keywords"
                render={({ input }) => (
                  <input
                    {...input}
                    type="text"
                    placeholder={intl.formatMessage({
                      id: 'KioskTopbar.searchPlaceholder',
                    })}
                    className={css.searchInput}
                    autoComplete="off"
                  />
                )}
              />
            </form>
          )}
        />
      </div>
    </header>
  );
};

export default KioskTopbar;
